import React, { useState, useEffect, useRef } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { Badge, message } from "antd";
import { setCookie } from "../../../utils/setCookie";
import "./index.scss";
import toTop from "../../../assets/images/pub/toTop.svg";
import toTop_d from "../../../assets/images/pub/toTop_d.svg";
import richToTop from "../../../assets/images/pub/rich-to-top.svg";
import richDark from "../../../assets/images/pub/rich-dark.svg";
import richLight from "../../../assets/images/pub/rich-light.svg";
import richConact from "../../../assets/images/pub/rich-conact.svg";
import richToTop_d from "../../../assets/images/pub/rich-to-top_d.svg";
import richDark_d from "../../../assets/images/pub/rich-dark_d.svg";
import richLight_d from "../../../assets/images/pub/rich-light_d.svg";
import richConact_d from "../../../assets/images/pub/rich-conact_d.svg";
import goBack from "../../../assets/images/pub/go-back.svg";
import { get_user_info } from "../../../api/kdsPosts";
import LoginModal from "../../LoginModal";
import ConfirmModal from "../ConfirmModal";

// 定义默认图片名称常量

function ToTop({
  type,
  currentTheme,
  onThemeChange,
  currentFontSize,
  onFontSizeChange,
}) {
  // type: -1 隐藏，0 精简，1：丰富
  // currentTheme: 从父组件传递的当前主题
  // onThemeChange: 从父组件传递的主题切换函数
  // currentFontSize: 从父组件传递的当前字体大小
  // onFontSizeChange: 从父组件传递的字体大小切换函数

  const [changeSaveModalVisible, setChangeSaveModalVisible] = useState(false);
  const [loginModalVisible, setLoginModalVisible] = useState(false);
  const [searchParams] = useSearchParams();
  const location = useLocation();
  // 使用父组件传递的主题，如果没有则使用本地存储
  const [theme, setTheme] = useState(
    currentTheme || localStorage.getItem("theme") || "light",
  );
  const [fontSize, setFontSize] = useState(
    currentFontSize || localStorage.getItem("fontSize") || "normal",
  );

  const [userInfo, setUserInfo] = useState(null);
  // 使用 useRef 保存最新 userInfo 的引用
  const userInfoRef = useRef();
  // 当父组件传递的主题变化时，更新本地状态
  useEffect(() => {
    if (currentTheme) {
      setTheme(currentTheme);
    }
  }, [currentTheme]);
  useEffect(() => {
    if (currentFontSize) {
      setFontSize(currentFontSize);
    }
  }, [currentFontSize]);

  useEffect(() => {
    if (!userInfo) {
      get_user_info({}).then((res) => {
        if (res.data && res.data?.msg !== "登录后有值") {
          setUserInfo(res.data?.data);
          userInfoRef.current = res.data.data;
        }
      });
    }
  }, [userInfo]);

  // 登陆成功
  const handleLoginSuccess = () => {
    setLoginModalVisible(false);
    // 处理登录成功后的逻辑
    window.location.reload();
  };

  // 背景色
  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme);
    document.body.setAttribute("data-theme", newTheme); // 更新body的data-theme属性
    // 如果父组件提供了主题切换函数，则调用它
    if (onThemeChange) {
      onThemeChange(newTheme);
    }
  };
  // 字体大小
  const toggleFontSize = () => {
    const newFontSize = fontSize === "normal" ? "big" : "normal";
    setFontSize(newFontSize);
    localStorage.setItem("fontSize", newFontSize);
    document.body.setAttribute("data-font-size", newFontSize);
    // 如果父组件提供了字体大小切换函数，则调用它
    if (onFontSizeChange) {
      onFontSizeChange(newFontSize);
    }
  };

  const [showTooltip, setShowTooltip] = useState(true);
  useEffect(() => {
    if (type === 1) {
      setShowTooltip(true);
      const timer = setTimeout(() => setShowTooltip(false), 5000);
      return () => clearTimeout(timer);
    }
  }, [type]);

  // 版本切换
  const checkVersion = () => {
    if (!userInfo) {
      setLoginModalVisible(true);
    } else {
      if (userInfo?.vip_status === 2 || userInfo?.vip_status === 3) {
        setCookie("return_to_old", 1, 7);
        if (location.pathname.includes("/new/thread/post")) {
          setChangeSaveModalVisible(true);
        } else if (location.pathname.includes("/new/thread/detail")) {
          const tempTid = searchParams.get("tid");
          window.location.href = `https://club.kdslife.com/t_${tempTid}.html`;
        } else if (location.pathname.includes("/new/home")) {
          window.location.href = `https://club.kdslife.com/f_15.html`;
        }
      }else{
         message.warning("旧版仅限会员使用~");
      }
    }
  };

  const goOld = () => {
    setChangeSaveModalVisible(false);
    window.location.href =
      "https://club.kdslife.com/index.php?c=thread/thread&m=send_thread&fid=15&tag_id=0";
  };

  return (
    <>
      {type === 0 ? (
        <div
          className="to-top"
          onClick={() => {
            window.scrollTo(0, 0);
          }}
        >
          <img className="icon" src={toTop} alt="toTop"></img>
          <div className="font">TOP</div>
        </div>
      ) : type === 1 ? (
        <div className="to-top-rich">
          <div
            className="rich-item"
            onClick={() => {
              window.scrollTo(0, 0);
            }}
            onMouseEnter={(e) => e.currentTarget.classList.add("hover")}
            onMouseLeave={(e) => e.currentTarget.classList.remove("hover")}
          >
            <img
              className="icon"
              src={theme === "light" ? richToTop : richToTop_d}
              alt="toTop"
            ></img>
            <div className="font">
              回到
              <br />
              顶部
            </div>
          </div>
          <div
            className="rich-item"
            onClick={() => {
              if (!userInfo) {
                setLoginModalVisible(true);
              } else {
                window.open("/new/notify?showIm=true");
              }
            }}
            onMouseEnter={(e) => e.currentTarget.classList.add("hover")}
            onMouseLeave={(e) => e.currentTarget.classList.remove("hover")}
          >
            <Badge
              className="custom-badge"
              size="small"
              count={
                userInfoRef.current?.user_not_read_msg_count ||
                userInfo?.user_not_read_msg_count
              }
              overflowCount={99}
            >
              <img
                className="icon"
                src={theme === "light" ? richConact : richConact_d}
                alt="contact"
              ></img>
            </Badge>
            <div className="font">
              消息
              <br />
              聊天
            </div>
          </div>
          <div
            className="rich-item"
            onClick={checkVersion}
            onMouseEnter={(e) => e.currentTarget.classList.add("hover")}
            onMouseLeave={(e) => e.currentTarget.classList.remove("hover")}
          >
            <div className="font">
              回到
              <br />
              旧版
            </div>
            <div className="font">
              回到
              <br />
              旧版
            </div>
          </div>
          {showTooltip && (
            <div className="tooltip">
              <img src={goBack} alt="tooltip"></img>
            </div>
          )}
          {theme === "light" ? (
            <div
              className="rich-item"
              onClick={toggleTheme}
              onMouseEnter={(e) => e.currentTarget.classList.add("hover")}
              onMouseLeave={(e) => e.currentTarget.classList.remove("hover")}
            >
              <img
                className="icon"
                src={theme === "light" ? richDark : richDark_d}
                alt="dark"
              ></img>
              <div className="font">
                暗夜
                <br />
                模式
              </div>
            </div>
          ) : (
            <div
              className="rich-item"
              onClick={toggleTheme}
              onMouseEnter={(e) => e.currentTarget.classList.add("hover")}
              onMouseLeave={(e) => e.currentTarget.classList.remove("hover")}
            >
              <img
                className="icon"
                src={theme === "light" ? richLight : richLight_d}
                alt="light"
              ></img>
              <div className="font">
                日间
                <br />
                模式
              </div>
            </div>
          )}
          {fontSize === "normal" ? (
            <div
              className="rich-item"
              onClick={toggleFontSize}
              onMouseEnter={(e) => e.currentTarget.classList.add("hover")}
              onMouseLeave={(e) => e.currentTarget.classList.remove("hover")}
            >
              <div className="font">
                大字
                <br />
                模式
              </div>
              <div className="font">
                大字
                <br />
                模式
              </div>
            </div>
          ) : (
            <div
              className="rich-item"
              onClick={toggleFontSize}
              onMouseEnter={(e) => e.currentTarget.classList.add("hover")}
              onMouseLeave={(e) => e.currentTarget.classList.remove("hover")}
            >
              <div className="font">
                正常
                <br />
                字体
              </div>
              <div className="font">
                正常
                <br />
                字体
              </div>
            </div>
          )}
        </div>
      ) : null}
      {/* 登录弹框 */}
      <LoginModal
        key={loginModalVisible ? "login-visible" : "login-hidden"}
        visible={loginModalVisible}
        onClose={() => setLoginModalVisible(false)}
        onSuccess={handleLoginSuccess}
      />
      {/* 切换通知 */}

      <ConfirmModal
        visible={changeSaveModalVisible}
        onClose={() => setChangeSaveModalVisible(false)}
        onConfirm={goOld}
        confirmButtonType="warning"
        confirmText="回到旧版"
        title="回到旧版将丢失编辑内容"
        message="您编辑的内容尚未保存，返回旧版将无法恢复这些内容。请确认您是否要继续？"
      />
    </>
  );
}

export default ToTop;
